// src/chatbot/data/services.js
import { Phone } from "lucide-react";
const services = {
  welcome: {
    id: "welcome",
    message:
      "👋 Welcome to GrowX!\nWe help businesses grow with AI, Websites, Mobile Apps, Digital Marketing, Branding, and  .\nHow can I help you today?",
    options: [
      {
        label: "🚀 Our Services",
        next: "services",
      },
      {
        label: "💰 Get a Free Quote",
        next: "quote",
      },
      {
        icon: <Phone size={10} color="white" />,
        label: "Contact Us",
        next: "contact",
      },
      {
        label: "❓ Ask a Question",
        next: "question",
      },
    ],
  },

  services: {
    id: "services",
    message: "Please choose a service you'd like to know more about.",
    options: [
      {
        label: "🌐 Website Development",
        next: "website",
      },
      {
        label: "📱 App Development",
        next: "app",
      },
      {
        label: "🤖 AI Solutions",
        next: "ai",
      },
      {
        label: "📈 Digital Marketing",
        next: "marketing",
      },
      {
        label: "🏠 Back to Home",
        next: "welcome",
      },
    ],
  },

  ai: {
    id: "ai",
    message:
      "🤖 GrowX builds AI-powered chatbots, workflow automation, predictive analytics, recommendation systems, and custom AI solutions to help businesses grow faster.",
    options: [
      {
        label: "🏠 Back to Home",
        next: "welcome",
      },
    ],
  },

  website: {
    id: "website",
    message:
      "We create modern, responsive, and SEO-friendly websites that help businesses build a strong online presence, engage customers, and drive growth.",
    options: [
      {
        label: "🏠 Back to Home",
        next: "welcome",
      },
    ],
  },

  app: {
    id: "app",
    message:
      "📱 We develop Android, iOS, and cross-platform mobile applications with intuitive UI, fast performance, and scalable architecture.",
    options: [
      {
        label: "🏠 Back to Home",
        next: "welcome",
      },
    ],
  },

  marketing: {
    id: "marketing",
    message:
      "📈 Our digital marketing services include SEO, Google Ads, Meta Ads, Social Media Marketing, Content Marketing, and Lead Generation.",
    options: [
      {
        label: "🏠 Back to Home",
        next: "welcome",
      },
    ],
  },

  branding: {
    id: "branding",
    message:
      "🎨 We help brands stand out with professional logo design, brand identity, UI/UX design, brochures, creatives, and complete branding solutions.",
    options: [
      {
        label: "🏠 Back to Home",
        next: "welcome",
      },
    ],
  },

  software: {
    id: "software",
    message:
      "💻 We build secure, scalable, and customized software including CRM, ERP, HRMS, inventory systems, dashboards, and enterprise applications.",
    options: [
      {
        label: "🏠 Back to Home",
        next: "welcome",
      },
    ],
  },

  quote: {
    id: "quote",
    message:
      "💰 Great! I'll help you get a free quote.\n\nLet's start with your name.",
    options: [],
  },

  question: {
    id: "question",
    message:
      "❓ Please type your question below.\n\nOur team will get back to you as soon as possible.",
    options: [],
  },

  contact: {
    id: "contact",
    message:
      "📞 Contact GrowX\n\n📧 Email: growx@samrattechitsolutions.com\n📱 Phone: +91 8802642136, +91 9598491005\n🌐 Website: growx.samrattechitsolutions.com",
    options: [
      {
        label: "🏠 Back to Home",
        next: "welcome",
      },
    ],
  },

  fallback: {
    id: "fallback",
    message:
      "😊 I'm sorry, I couldn't understand that.\n\nPlease choose one of the available options below.",
    options: [
      {
        label: "🏠 Back to Home",
        next: "welcome",
      },
    ],
  },
};

export default services;